module.exports = __webpack_public_path__ + "img/icon_map_huanjingjiankong_zaixian.f0647960.svg";